// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import { QRCode as QR } from 'react-qr-code';

const Disclaimer = styled.div`
    text-align: center;
    font-size: 0.75em;
    color: #888;
    margin-top: 0.25em;
`;

const QRCode = ({ data, live = false, expireTime, ...props }) => {
    const { state: {
        isOffline
    } } = useGlobalState();

    const [dataSrc, setDataSrc] = useState(data)

    useEffect(() => {
        setDataSrc(data)
    }, [data])

    if (isOffline) return null;

    if (!live) return (
        <QR
            size={256}
            style={{ height: "100px", maxWidth: "100%", width: "100%" }}
            value={dataSrc}
            viewBox={`0 0 256 256`}
        />
    );

    return (
        <>
            <QR
                size={256}
                style={{ height: "100px", maxWidth: "100%", width: "100%" }}
                value={dataSrc}
                viewBox={`0 0 256 256`}
            />
            <Disclaimer>{expireTime ? `This code expires ${expireTime} seconds after generation — screenshots will not scan.` : 'This code is live and updates automatically — screenshots will not scan.'}</Disclaimer>
        </>
    )
}

export default QRCode;